var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"dashboard-container"},[_c('Order',{attrs:{"instrumentId":_vm.data.id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }